export default __webpack_public_path__ + "static/media/ic_logo.0c4b7453.png";